module.exports = __webpack_public_path__ + "static/img/04-app-configurations.f8d6791.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lti-setup-guide/04-app-configurations.png
// module id = X1zt
// module chunks = 1